import { styled } from '@mui/material/styles';
import { Alert } from 'shared/mui/Alert/Alert';

export const AlertStyled = styled(Alert)({
  marginBottom: '16px',
  marginTop: '4px',
});
